import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { IndividualPaymentDue, PaymentDuesFilters, SubsPaymentDue } from "./payment-dues.entity";
import { getVendorPaymentDues } from "./payment-dues.api";

interface PaymentDuesState {
  individualPaymentDues: IndividualPaymentDue[];
  subsPaymentDues: SubsPaymentDue[];
  loading: boolean;
  error: string | null;
}

const initialState: PaymentDuesState = {
  individualPaymentDues: [],
  subsPaymentDues: [],
  loading: false,
  error: null,
};

export const fetchVendorPaymentDues = createAsyncThunk("paymentDues/fetchVendor", async (filters?: PaymentDuesFilters) => {
  return await getVendorPaymentDues(filters);
});

const paymentDuesSlice = createSlice({
  name: "paymentDues",
  initialState,
  reducers: {},
  extraReducers: (builder) =>
    builder
      .addCase(fetchVendorPaymentDues.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchVendorPaymentDues.fulfilled, (state, action) => {
        state.loading = false;
        state.individualPaymentDues = action.payload.individual;
        state.subsPaymentDues = action.payload.subs;
      })
      .addCase(fetchVendorPaymentDues.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message ?? "Failed to load payment dues";
      }),
});

export default paymentDuesSlice.reducer;
